<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Errors in Voucher Import</span>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="voucherHeaders"
        :items="voucherErr"
        class="elevation-1"
        :hide-default-footer="true"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'HandleVoucherSequenceError',
  props: {
    voucherSequenceErrors: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    voucherHeaders: [
      { text: 'FY', value: 'fiscalYear' },
      { text: 'Department', value: 'deptNumber' },
      { text: 'Voucher Number', value: 'importVoucherNumber' },
      { text: 'Problem', value: 'problem' },
      { text: 'Expected ', value: 'maxVoucherNumber' },
      { text: 'Dept Balance ', value: 'deptBalance' },
    ],
  }),
  computed: {
    voucherErr() {
      const value = this.voucherSequenceErrors.length > 0 ? this.voucherSequenceErrors : [];
      return value;
    },
    isErrorWithHeader() {
      return this.errorMode === 'errorWithHeader';
    },
  },
  methods: {
    proceedImportFile() {
      this.$emit('proceedImportFile', true);
    },
  },
};
</script>
